module.exports = __webpack_public_path__ + "img/5.dc64ace5.jpg";